import { LegalClientSaveTargetedFinancialInstrumentsParam } from 'api/types/params';

import { TargetedFinancialInstrumentsFormType } from '../../forms/targetedFinancialInstrumentsForm';

const parseFinancialInstruments = (
  v: TargetedFinancialInstrumentsFormType['financialInstruments']['bonds']
) =>
  v?.enabled
    ? {
        monthlyTradeAmount: v?.monthlyTradeAmount,
        yearlyTradeAmount: v.yearlyTradeAmount!,
      }
    : undefined;

export const getSubmitData = (
  values: TargetedFinancialInstrumentsFormType
): LegalClientSaveTargetedFinancialInstrumentsParam => ({
  financialInstruments: {
    bonds: parseFinancialInstruments(values.financialInstruments?.bonds),
    derivatives: parseFinancialInstruments(
      values.financialInstruments?.derivatives
    ),
    mutualFunds: parseFinancialInstruments(
      values.financialInstruments?.mutualFunds
    ),
    stocks: parseFinancialInstruments(values.financialInstruments?.stocks),
    structuredProducts: parseFinancialInstruments(
      values.financialInstruments?.structuredProducts
    ),
    otherFinancialInstruments: parseFinancialInstruments(
      values.financialInstruments?.otherFinancialInstruments
    ),
  },
  operationsDetails: {
    expectedMonthlyTradeQuantity: values.expectedMonthlyTradeQuantity!,
    expectedYearlyTradeQuantity: values.expectedYearlyTradeQuantity!,
  },
});
